import { EventHandler, blockEvent } from '../../utils/dom-events';

class ContextMenuBlocker {
  constructor(el) {
    this.el = el;
    this.handler = new EventHandler(this.el, 'contextmenu', this.test.bind(this));
    this.handler.start();
  }

  test(event) {
    if (
      this.el === event.target
      || this.el.contains(event.target)
    ) {
      blockEvent(event);
    }
  }

  destroy() {
    this.handler.destroy();
  }
}

export default ContextMenuBlocker;
